import { provideConfig } from '@spartacus/core'
import { NgModule } from '@angular/core'
import { CENTERED_TEXT_CONVERTER_TOKEN, CenteredTextConverter } from './centered-text.component.converter'
import { FsComponentConverter } from 'fs-spartacus-common'

@NgModule({
  providers: [
    provideConfig({
      featureModules: {
        centeredTextFeature: {
          module: () => import('./centered-text.module').then((m) => m.CenteredTextModule),
          cmsComponents: ['centered_text'],
        },
      }
    }),
    {
      provide: CENTERED_TEXT_CONVERTER_TOKEN,
      useExisting: CenteredTextConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        centered_text: CENTERED_TEXT_CONVERTER_TOKEN
      },
      multi: true
    },
  ]
})
export class CenteredTextFeatureModule {}
